export default {
    common: {
        email_address_long: 'Email Address',
        email_address_short: 'Email',
        phone_number: 'Phone Number',
        fax_number: 'Fax',
        address: 'Address',
        country: 'Country',
        city: 'City',
        post_code_short: 'Post Code',
        street_name_short: 'Street',
        street_name_long: 'Street Name',
        street_number: 'Street Nr.',
        additional_address_info_short: 'Address info',
        additional_address_info_long: 'Additional address infomations',
        country_austria: 'Austria',
        country_germany: 'Germany',
        country_switzerland: 'Switzerland',
    },

    operator: {
        operator: 'Operator',
        general_tab: 'General',
        invoices_tab: 'Invoices',
        sms_quota_tab: 'SMS Quota',
        additional_operators_tab: 'Additional Operators',
        company_club: 'Company | Club',
        name_label: 'Name',
        name_placeholder: 'Name/Surname',
        uid_number_label: 'UID',
        uid_number_placeholder: 'UID Number',
        fn_number_label: 'FN',
        fn_number_placeholder: 'FN 9999999X',
        zvr_number_label: 'ZVR',
        zvr_number_placeholder: 'ZVR Number',
        dvr_number_label: 'DVR',
        dvr_number_placeholder: 'DVR Number',
        homepage: 'Homepage',
        email_signature: 'Email Signature',
    }
};
